import { GetConversationListRequest } from "@amzn/atlas-chat-react-library";
import { startOfDay, endOfDay, subDays } from "date-fns";

interface ConversationListRequestsParams {
  user: string;
  appId: string;
}

export function buildConversationListRequests(
  params: ConversationListRequestsParams,
): GetConversationListRequest[] {
  const { user, appId } = params;
  const base = { user, appId };
  const now = new Date();

  return [
    {
      ...base,
      startDate: Math.floor(startOfDay(now).getTime() / 1000),
      endDate: Math.floor(endOfDay(now).getTime() / 1000),
    },
    {
      ...base,
      startDate: Math.floor(startOfDay(subDays(now, 1)).getTime() / 1000),
      endDate: Math.floor(endOfDay(subDays(now, 1)).getTime() / 1000),
    },
    {
      ...base,
      startDate: Math.floor(startOfDay(subDays(now, 7)).getTime() / 1000),
      endDate: Math.floor(endOfDay(subDays(now, 2)).getTime() / 1000),
    },
    {
      ...base,
      startDate: Math.floor(startOfDay(subDays(now, 30)).getTime() / 1000),
      endDate: Math.floor(endOfDay(subDays(now, 8)).getTime() / 1000),
    },
  ];
}
